export const MARKETPLACE_INTRODUCTION_ID = 'marketplace-introduction-section';
export const HERO_BANNER_SECTION_ID = 'hero-banner-section';
